import './alert-container.scss'

import { defineComponent } from 'vue'

import { DISPLAY_ALERT_TOPIC } from '@skinsoft/bus/src/busTopics'
import { reactiveVueMixin } from '@skinsoft/reactive-vue'

export const AlertContainer = defineComponent({
    mixins: [reactiveVueMixin],
    template: require('./alert-container.html'),
    data() {
        return {
            alertMessage: '',
            alertVariant: '',
            show: false,
            saveAlertTimeout: null as any,
        }
    },
    mounted() {
        this.subscribeToBus(DISPLAY_ALERT_TOPIC, (message) => {
            if (message.payload) {
                this.showAlert(message.payload)
            }
        })
    },
    methods: {
        showAlert(alertData: any) {
            const SAVE_ALERT_DURATION = 3000
            clearTimeout(this.saveAlertTimeout)
            this.show = false
            this.alertMessage = alertData.message
            this.alertVariant = alertData.variant
            setTimeout(() => {
                this.show = true
                this.saveAlertTimeout = setTimeout(() => {
                    this.show = false
                }, SAVE_ALERT_DURATION)
            }, 200)
        },
    },
})
